import { createSlice } from "@reduxjs/toolkit";

const lineitemErrorsSlice = createSlice({
  name: "lineitemErrors",
  initialState: {
    errors: [], // Array of { productId, error, lineitem }
  },
  reducers: {
    setLineitemErrors(state, action) {
      state.errors = action.payload;
    },
    clearLineitemErrors(state) {
      state.errors = [];
    },
    addLineitemError(state, action) {
      const { productId, error, lineitem } = action.payload;
      state.errors.push({ productId, error, lineitem });
    },
    removeLineitemError(state, action) {
      const productId = action.payload;
      state.errors = state.errors.filter(err => err.productId !== productId);
    }
  },
});

export const { 
  setLineitemErrors, 
  clearLineitemErrors, 
  addLineitemError, 
  removeLineitemError 
} = lineitemErrorsSlice.actions;

export default lineitemErrorsSlice.reducer;
